import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import DeleteTicketMutation from '../../../../../mutations/ticketing/tickets/deleteTicketMutation';

interface UseDeleteTicketResult {
	submit: (id: string, connections?: string[]) => Promise<string>;
	loading: boolean;
	error: string | null;
}

export function useDeleteTicket(): UseDeleteTicketResult {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(id: string, connections: string[] = []): Promise<string> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				DeleteTicketMutation,
				{id, connections},
				response => {
					setLoading(false);
					resolve(response.deleteTicket.deletedTicketId);
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
